import type { ThemeColorModes, ThemeState } from '@atlaskit/tokens/theme-config';

export const themeColorModes: ThemeColorModes[] = ['light', 'dark', 'auto'] as const;
export const DEFAULT_COLOR_MODE: ThemeColorModes = 'auto';
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export const DEFAULT_THEME: Partial<ThemeState> = {
	dark: 'dark',
	light: 'light',
	colorMode: DEFAULT_COLOR_MODE,
	typography: 'typography',
};
